import React, { useEffect, useState } from "react";
import { Bot, ArrowLeft, User } from "lucide-react";
import api from "../lib/api";

export default function AILogs() {
  const [sessions, setSessions] = useState([]);
  const [active, setActive] = useState(null);
  const [msgs, setMsgs] = useState([]);

  useEffect(() => { api.get("/ai/sessions").then((r) => setSessions(r.data)).catch(() => {}); }, []);

  const open = (sid) => {
    setActive(sid);
    api.get(`/ai/sessions/${sid}`).then((r) => setMsgs(r.data)).catch(() => {});
  };

  return (
    <div>
      <h1 className="font-display text-2xl md:text-3xl font-bold text-[#012a1e]">AI Counsellor Logs</h1>
      <p className="text-slate-500 mt-1 text-sm">Review conversations students had with Vidya AI.</p>

      {!active ? (
        <div className="bg-white rounded-2xl border border-slate-100 mt-5 divide-y divide-slate-100">
          {sessions.map((s) => (
            <button key={s.session_id} onClick={() => open(s.session_id)} className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-[#f7faf8]">
              <div className="flex items-center gap-3 min-w-0">
                <div className="w-10 h-10 rounded-full bg-[#004030] text-[#e0c05a] grid place-items-center shrink-0"><Bot size={18} /></div>
                <div className="min-w-0"><p className="font-medium text-[#012a1e] truncate">{s.last}</p><p className="text-xs text-slate-400">{s.messages} messages · {new Date(s.last_at).toLocaleString()}</p></div>
              </div>
            </button>
          ))}
          {!sessions.length && <p className="px-5 py-10 text-center text-slate-400">No AI conversations yet.</p>}
        </div>
      ) : (
        <div className="mt-5">
          <button onClick={() => setActive(null)} className="flex items-center gap-2 text-sm text-slate-500 hover:text-[#004030] mb-3"><ArrowLeft size={16} /> Back to sessions</button>
          <div className="bg-white rounded-2xl border border-slate-100 p-5 space-y-3 max-w-3xl">
            {msgs.map((m) => (
              <div key={m.id} className={`flex gap-3 ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                {m.role === "assistant" && <div className="w-8 h-8 rounded-full bg-[#004030] text-[#e0c05a] grid place-items-center shrink-0"><Bot size={16} /></div>}
                <div className={`max-w-[75%] px-4 py-2.5 rounded-2xl text-sm ${m.role === "user" ? "bg-[#004030] text-white" : "bg-[#f7faf8] text-slate-700"}`}>{m.text}</div>
                {m.role === "user" && <div className="w-8 h-8 rounded-full bg-[#c9a227] text-[#013d2b] grid place-items-center shrink-0"><User size={16} /></div>}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
